import { render, staticRenderFns } from "./CustomVerticalCalendar.vue?vue&type=template&id=3774a06e"
import script from "./CustomVerticalCalendar.vue?vue&type=script&lang=js"
export * from "./CustomVerticalCalendar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports